import { useState, useEffect } from 'react';

export default function SearchTermSuggestions({searchTerm, useSuggestion, onDebugData}) {
  const limit = 5;
  const [suggestions, setSuggestions] = useState([]);
  const [previousSearchTerm, setPreviousSearchTerm] = useState('');
  const [searchRequestTimeout, setSearchRequestTimeout] = useState(null);

  useEffect(() => {
    let isMounted = true;

    if (previousSearchTerm !== searchTerm) {
      setPreviousSearchTerm(searchTerm);

      if (searchRequestTimeout) {
        clearTimeout(searchRequestTimeout);
      }

      if (searchTerm.length < 2) {
        setSuggestions([]);
      } else {
        setSearchRequestTimeout(setTimeout(() => {
          const url = '/search_api_autocomplete/flink_word_suggestions?q=' + encodeURIComponent(searchTerm);
          fetch(url)
            .then(response => response.json())
            .then(data => {
              if (isMounted) {
                setSuggestions(data);
                onDebugData?.({url, response: data});
              }
            });
        }, 300))
      }
    }

    return () => {isMounted = false;};

  }, [searchTerm]);

  function handleSuggestionClick(e, suggestion) {
    e.preventDefault();
    useSuggestion(suggestion.value);
  }

  // Highlight the typed prefix inside the suggestion value.
  // suggestion.value is plain text so no HTML parsing is needed.
  function renderSuggestion(value) {
    const lower = value.toLowerCase();
    const matchIndex = lower.indexOf(searchTerm.toLowerCase());
    if (matchIndex === -1) {
      return <span>{value}</span>;
    }
    return (
      <>
        {value.substring(0, matchIndex)}
        <em>{value.substring(matchIndex, matchIndex + searchTerm.length)}</em>
        {value.substring(matchIndex + searchTerm.length)}
      </>
    );
  }

  if (!suggestions) {
    return '';
  }

  return (
    <>
      {suggestions.length > 0 &&
        <li className={"search-results__item"} key={'search-term-suggestions'} data-fcs-region="search_term_results">
          <h3 className="search-results__heading">Zoeksuggesties</h3>
          <div className={"search-results__wrapper"}>
            <ul className={"search-result__list"}>
              {suggestions.slice(0, limit).map((suggestion, index) => (
                <li className={"search-result"} key={index}>
                  <a className={"search-result__suggestion"} href="#" onClick={(e) => handleSuggestionClick(e, suggestion)}>
                    {renderSuggestion(suggestion.value)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </li>
      }
    </>
  );
}
